import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setRefetch, setRefetchKey } from '../../../features/folder/folderSlice';
import CompletedDirectPaymentTable from './CompletedDirectPaymentTable';
import PendingDirectPaymentTable from './PendingDirectPaymentTable';
import { Tabs } from 'antd';
import InsideHeader from '../../../components/InsideHeader';

function DirectPaymentList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [active, setactive] = useState("1");
    async function refetching(activeKey) {
      await dispatch(setRefetch());
      await dispatch(setRefetchKey(activeKey)); 
        await setactive(activeKey); 
    }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Pending Payment</span>
        </span>
      ),
      key: "1",
      children: <PendingDirectPaymentTable />,
    },

    {
      label: (
        <span className="flex items-center">
          <span className="">Completed</span>
        </span>
      ),
      key: "2",
      children: <CompletedDirectPaymentTable/>,
    },
     
  ];
  return (
    <div className='w-full h-full overflow-y-scroll'>
        <InsideHeader
        title="Direct Payment"
        subtitle="Initialize Direct Payments within your institution"
        back={false}
      />
        <div className="h-[111px]  mt-[1rem] lg:px-10 px-3">
          <Tabs
            items={tabConfigurations}
            defaultActiveKey="1"
            activeKey={active}
            onChange={refetching}
            className="activity-tab activity-tab-wrap activity-bar"
          />
        </div>
    </div>
  )
}

export default DirectPaymentList